import Vue from 'vue'
import Vuex from 'vuex'
import SeismicForm from '@/models/SeismicForm'
import { FormsStatus, FormsStore } from '@/types'
import Inspector from '@/models/Inspector'
import Team from '@/models/Team'
import Campaign from '@/models/Campaign'

Vue.use(Vuex)

export default new Vuex.Store<FormsStore>({
  state: {
    appTitle: 'Ofis',
    indexedDBName: 'ofis',
    indexedDBVersion: 8,
    indexedDBRequest: null,
    indexedDBResult: null,
    seismicForms: [],
    selectedCampaign: '',
    selectedCampaignSeismicForms: [],
    selectedSeismicForm: null,
    inspectors: [],
    teams: [],
    selectedInspectors: [],

    numberFilter: '' as string,
    batFilter: '' as string,
    localFilter: '' as string,
    commentFilter: '' as string,
    statusFilter: '' as string,
    dateFilter: '' as string,

    pinnedForms: [],

    isPrintablePDFMode: false,

    uploadedFileName: undefined,
    uploadedFileContent: undefined

  },

  getters: {
    getSeismicForms (state) : Array<SeismicForm> {
      return state.seismicForms.sort((a: SeismicForm, b: SeismicForm) => {
        const aPart = a.numeroFiche.split('-')
        const bPart = b.numeroFiche.split('-')
        return aPart[0].toLowerCase().localeCompare(bPart[0].toLowerCase()) || (aPart[1] as any) - (bPart[1] as any)
      })
    },
    getSelectedCampaign (state) : string {
      return state.selectedCampaign
    },
    getSelectedCampaignSeismicForms (state) : Array<SeismicForm> {
      return state.selectedCampaignSeismicForms.sort((a: SeismicForm, b: SeismicForm) => {
        const aPart = a.numeroFiche.split('-')
        const bPart = b.numeroFiche.split('-')
        return aPart[0].toLowerCase().localeCompare(bPart[0].toLowerCase()) || (aPart[1] as any) - (bPart[1] as any)
      })
    },
    getSelectedSeismicForm: (state) => {
      return state.selectedSeismicForm
    },
    getSeismicForm: (state) => (campaign: string, seismicFormId: string): SeismicForm => {
      console.log('GETTER', campaign, seismicFormId, JSON.parse(JSON.stringify(state.seismicForms)))
      console.log('GETTER', state.seismicForms.filter(form => form.numeroFiche === seismicFormId && form.campaign === campaign)[state.seismicForms.length - 1])
      return state.seismicForms.filter(form => form.numeroFiche === seismicFormId && form.campaign === campaign)[0]
    },
    getInspectors: (state) : Array<Inspector> => {
      return state.inspectors
    },
    getSelectedInspectors (state): Array<Inspector> {
      return state.selectedInspectors
    },
    getTeams: (state) : Array<Team> => {
      return state.teams
    },
    getPinnedForms: (state): Array<SeismicForm> => {
      return state.pinnedForms
    },
    getIsPrintablePDFMode: (state): boolean => {
      return state.isPrintablePDFMode
    },

    getNumberFilter (state) {
      return state.numberFilter
    },
    getBatFilter (state) {
      return state.batFilter
    },
    getLocalFilter (state) {
      return state.localFilter
    },
    getCommentFilter (state) {
      return state.commentFilter
    },
    getStatusFilter (state) {
      return state.statusFilter
    },

    uploadedFileName (state) {
      return state.uploadedFileName
    },
    uploadedFileContent (state) {
      return state.uploadedFileContent
    }
  },

  mutations: {
    SET_INDEXED_BD_REQUEST (state) {
      console.debug('[STORE]', 'Initialise la connexion à la base de données')
      // eslint-disable-next-line no-constant-condition
      if ((!state.indexedDBRequest) || true) {
        state.indexedDBRequest = self.indexedDB.open(state.indexedDBName, state.indexedDBVersion)
        state.indexedDBRequest.onupgradeneeded = function (event: any) {
          console.log(`Base de données mise à jour en version ${state.indexedDBVersion}`)
          event.target.result.createObjectStore('seismicForms', { keyPath: ['campaign', 'numeroFiche'] })
          event.target.result.createObjectStore('inspectors', { keyPath: ['firstName', 'lastName'] })
          event.target.result.createObjectStore('teams', { keyPath: ['name'] })
        }
        state.indexedDBRequest.onsuccess = function (event: any) {
          state.indexedDBResult = event.target.result

          // Feeding Vuex Seismic Forms from IndexedDB
          const seismicFormsStore = state.indexedDBResult.transaction('seismicForms', 'readwrite').objectStore('seismicForms')
          const response = seismicFormsStore.getAll()
          response.onsuccess = () => {
            console.log('INIT FORMS', response.result)
            state.seismicForms.splice(0, state.seismicForms.length)
            response.result.forEach((form: SeismicForm) => {
              state.seismicForms.push(form)
            })
            console.log(JSON.parse(JSON.stringify(state.seismicForms)))
          }

          // Feeding Vuex Inspectors from IndexedDB
          const inspectorsForm = state.indexedDBResult.transaction('inspectors', 'readonly').objectStore('inspectors')
          const inspectorsList = inspectorsForm.getAll()
          inspectorsList.onsuccess = () => {
            state.inspectors.splice(0, state.inspectors.length)
            inspectorsList.result.forEach((inspector: Inspector) => {
              state.inspectors.push(inspector)
            })
          }

          // Feeding Vuex Teams from IndexedDB
          const teamsForm = state.indexedDBResult.transaction('teams', 'readonly').objectStore('teams')
          const teamsList = teamsForm.getAll()
          state.teams.splice(0, state.teams.length)
          teamsList.onsuccess = () => {
            teamsList.result.forEach((team: Team) => {
              state.teams.push(team)
            })
          }
        }
      }
    },

    INSERT_SEISMIC_FORMS (state, form: SeismicForm) {
      console.debug('[STORE]', 'Insertion dans VueX', form)
      state.seismicForms.push(form)
    },

    SET_SELECTED_CAMPAIGN_SEISMIC_FORMS (state, forms: SeismicForm) {
      console.debug('[STORE]', 'Insertion dans VueX', forms)
      // Empty selected campaign selected forms and replace them with new received values
      state.selectedCampaignSeismicForms.splice(0, state.selectedCampaignSeismicForms.length, forms)
    },

    SET_SELECTED_CAMPAIGN (state, campaign: string) {
      console.debug('[STORE]', 'Insertion dans VueX')
      state.selectedCampaign = campaign
    },

    SET_SELECTED_SEISMIC_FORM (state, seismicForm: SeismicForm) {
      state.selectedSeismicForm = seismicForm
    },

    UPDATE_SEISMIC_FORMS (state, newForm: SeismicForm) {
      console.debug('[STORE]', 'Mise à jour dans IndexedDB', newForm)
      // TODO: check that the form is well formed before update
      const formIndex = state.seismicForms.findIndex((form: SeismicForm, index) => {
        if (form.numeroFiche === newForm.numeroFiche) { return index }
      })
      state.seismicForms.splice(formIndex, 1, newForm)
    },

    REMOVE_CAMPAIGN (state, campaign: Campaign) {
      const newList: Array<SeismicForm> = []
      state.seismicForms.forEach((form: SeismicForm) => {
        if (form.campaign !== (campaign as any).title) {
          newList.push((JSON.parse(JSON.stringify(form))))
        }
      })
      state.seismicForms.splice(0, state.seismicForms.length, ...newList)
    },

    INSERT_INSPECTOR (state, newInspector: Inspector) {
      state.inspectors.push(newInspector)
    },

    INSERT_TEAM (state, newTeam: Team) {
      state.teams.push(newTeam)
    },

    INSERT_PIN_FORM (state, newForm: SeismicForm) {
      state.pinnedForms.push(newForm)
    },

    UPDATE_PRINTABLE_PDF_MODE (state, value: boolean) {
      state.isPrintablePDFMode = value
    },

    ADD_SELECTED_INSPECTOR (state, inspector: Inspector) {
      // Add the inspector if they are not already two
      state.selectedInspectors.length < 2 && state.selectedInspectors.push(inspector)
    },
    REMOVE_SELECTED_INSPECTOR (state, inspectorToRemove: Inspector) {
      // Remove the inspectorToRemove if exists in array
      console.log('REMOVE INSPECTOR', inspectorToRemove)
      for (let i = 0; i < state.inspectors.length; i++) {
        const currentInspector = state.inspectors[i]
        if (currentInspector.firstName === inspectorToRemove.firstName && currentInspector.lastName === inspectorToRemove.lastName) {
          console.log('REMOVE INSPECTOR: found at', i)
          state.inspectors.splice(i, 1)
          return
        }
      }
    },
    UPDATE_SELECTED_CAMPAIGN_SEISMIC_FORM (state, seismicForm : SeismicForm) {
      const index = state.selectedCampaign.forms.findIndex((form : SeismicForm) => form.numeroFiche === seismicForm.numeroFiche)
      Vue.set(state.selectedCampaign.forms, index, seismicForm)
    },

    SET_NUMBER_FILTER (state, value) {
      state.numberFilter = value
    },
    SET_BAT_FILTER (state, value) {
      state.batFilter = value
    },
    SET_LOCAL_FILTER (state, value) {
      state.localFilter = value
    },
    SET_COMMENT_FILTER (state, value) {
      state.commentFilter = value
    },
    SET_STATUS_FILTER (state, value) {
      state.statusFilter = value
    },
    SET_DATE_FILTER (state, value) {
      state.dateFilter = value
    },

    SET_UPLOAD_FILE_NAME (state, payload) {
      state.uploadedFileName = payload
    },
    SET_UPLOAD_FILE_CONTENT (state, payload) {
      state.uploadedFileContent = payload
    }

  },

  actions: {
    initializeIndexedDB (context) {
      context.commit('SET_INDEXED_BD_REQUEST')
    },

    insertSeismicForm (context, seismicForm: SeismicForm) {
      console.debug('[STORE]', 'Insert SeismicForm successfully', JSON.parse(JSON.stringify(seismicForm)))
      const transaction = context.state.indexedDBResult.transaction('seismicForms', 'readwrite')
      transaction.oncomplete = function () {
        context.commit('INSERT_SEISMIC_FORMS', seismicForm)
      }
      transaction.onerror = function () {
        // TODO: throw snackbar error instead of throwing error (in calling view probably)
        throw (new Error('Fiche déjà chargée pour cette campagne'))
      }
      transaction.objectStore('seismicForms').add(seismicForm)
      return transaction
    },

    selectCampaign (context, campaign: Campaign) {
      context.commit('SET_SELECTED_CAMPAIGN', campaign)
      if (campaign) {
        context.commit('SET_SELECTED_CAMPAIGN_SEISMIC_FORMS', context.state.seismicForms.filter((form: SeismicForm) => form.campaign === campaign))
      }
    },

    selectForm (context, seismicForm: SeismicForm) {
      this.commit('SET_SELECTED_SEISMIC_FORM', seismicForm)
    },

    updateSeismicForm (context, seismicForm: SeismicForm) {
      console.debug('[INDEXEDDB]', 'Update SeismicForm successfully', JSON.parse(JSON.stringify(seismicForm.analysis.conclusion)))
      // TODO : check why date update doesn't work when changed from the list
      const oldForm = context.getters.getSeismicForm(seismicForm.campaign, seismicForm.numeroFiche)
      console.log('UPDATE DATE check', [FormsStatus.done, FormsStatus.other].indexOf(oldForm.status))
      if ([FormsStatus.done, FormsStatus.other].indexOf(seismicForm.status) >= 0 &&
        ([FormsStatus.done, FormsStatus.other].indexOf(oldForm.status) < 0)) {
        console.log('UPDATE DATE check')
        seismicForm.updateDate = new Date()
      }
      context.commit('UPDATE_SEISMIC_FORMS', seismicForm)

      // TODO : update campainForms
      if (context.state.selectedCampaign) {
        context.commit('UPDATE_SELECTED_CAMPAIGN_SEISMIC_FORM', seismicForm)
      }
      const transaction = context.state.indexedDBResult.transaction('seismicForms', 'readwrite')
      transaction.objectStore('seismicForms').put(seismicForm)
    },

    removeCampaign (context, campaign: Campaign) {
      console.debug('[STORE]', 'Remove campaign', JSON.parse(JSON.stringify(campaign)))
      const transaction = context.state.indexedDBResult.transaction('seismicForms', 'readwrite')

      transaction.oncomplete = function () {
        context.commit('REMOVE_CAMPAIGN', campaign)
      }
      transaction.onerror = function () {
        throw (new Error('Impossible de supprimer la campagne'))
      }

      context.state.seismicForms.forEach((form: SeismicForm) => {
        if (form.campaign === (campaign as any).title) {
          console.log('--> remove ', `${form.campaign},${form.numeroFiche}`)
          transaction.objectStore('seismicForms').delete([form.campaign, form.numeroFiche])
        }
      })
    },

    insertInspector (context, inspector: Inspector) {
      const transaction = context.state.indexedDBResult.transaction('inspectors', 'readwrite')
      transaction.oncomplete = () => {
        console.debug('[INDEXEDDB]', 'Insert inspector successfully', JSON.parse(JSON.stringify(inspector)))
        context.commit('INSERT_INSPECTOR', inspector)
      }
      transaction.objectStore('inspectors').add(inspector)
    },

    removeUser (context, user: Inspector) {
      console.debug('[STORE]', 'Remove inspector', JSON.parse(JSON.stringify(user)))
      const transaction = context.state.indexedDBResult.transaction('inspectors', 'readwrite')

      transaction.oncomplete = function () {
        context.commit('REMOVE_SELECTED_INSPECTOR', user)
      }
      transaction.onerror = function () {
        throw (new Error('Impossible de supprimer la campagne'))
      }

      context.state.inspectors.forEach((inspector: Inspector) => {
        if (inspector.lastName === (user as Inspector).lastName && inspector.firstName === (user as Inspector).firstName) {
          console.log('--> remove ', `${inspector.firstName},${inspector.lastName}`)
          transaction.objectStore('inspectors').delete([inspector.firstName, inspector.lastName])
        }
      })
    },

    insertTeam (context, team: Team) {
      const transaction = context.state.indexedDBResult.transaction('teams', 'readwrite')
      console.log('ping')
      transaction.oncomplete = () => {
        console.debug('[INDEXEDDB]', 'Insert team successfully', JSON.parse(JSON.stringify(team)))
        context.commit('INSERT_TEAM', team)
      }
      transaction.objectStore('teams').add(JSON.parse(JSON.stringify(team)))
    },

    pinForm (context, newForm: SeismicForm) {
      const isAlreadyPinned = context.state.pinnedForms.filter(form =>
        form.numeroFiche === newForm.numeroFiche &&
        form.campaign === newForm.campaign).length > 0
      isAlreadyPinned || context.commit('INSERT_PIN_FORM', newForm)
    },
    unpinForm (context, form: SeismicForm) {
      let index = 0
      let notFinished = true
      while (notFinished) {
        const currentForm = context.state.pinnedForms[index]
        if (form.numeroFiche === currentForm.numeroFiche &&
        form.campaign === currentForm.campaign) {
          context.state.pinnedForms.splice(index, 1)
          notFinished = false
          break
        }
        index++
      }
    },

    activatePrintablePDFMode (context) {
      context.commit('UPDATE_PRINTABLE_PDF_MODE', true)
    },
    deactivatePrintablePDFMode (context) {
      context.commit('UPDATE_PRINTABLE_PDF_MODE', false)
    },

    selectInspector (context, inspector: Inspector) {
      // select an inspector if they are less than 2 already selected
      context.state.selectedInspectors.length < 2 && context.commit('ADD_SELECTED_INSPECTOR', inspector)
    },
    unselectInspector (context, inspector: Inspector) {
      context.commit('REMOVE_SELECTED_INSPECTOR', inspector)
    },

    setNumberFilter (context, value) {
      context.commit('SET_NUMBER_FILTER', value)
    },
    setBatFilter (context, value) {
      context.commit('SET_BAT_FILTER', value)
    },
    setLocalFilter (context, value) {
      context.commit('SET_LOCAL_FILTER', value)
    },
    setCommentFilter (context, value) {
      context.commit('SET_COMMENT_FILTER', value)
    },
    setStatusFilter (context, value) {
      context.commit('SET_STATUS_FILTER', value)
    },
    setDateFilter (context, value) {
      context.commit('SET_DATE_FILTER', value)
    },

    uploadFile (context, value) {
      context.commit('SET_UPLOAD_FILE_NAME', value.fileName)
      context.commit('SET_UPLOAD_FILE_CONTENT', value.fileContent)
    },

    clearUploadFile (context) {
      context.commit('SET_UPLOAD_FILE_NAME', undefined)
      context.commit('SET_UPLOAD_FILE_CONTENT', undefined)
    }

  },
  modules: {
  }
})
